module.exports = __webpack_public_path__ + "static/media/Logo-B-Free_0001_Livello-1-copia.6d6d6da5.png";